import Vue from 'vue';
import { beforeRouteEnter } from '@assets/js/routerPageHook.js';
import filterContainer from '@components/ui-components/filter-container/filter-container.vue';
import reviewsItem from '@components/ui-components/reviews-item/component.js';
import LoadMore from '@components/ui-components/load-more/load-more';
import formReviews from '@components/base/forms/form-reviews.vue';
import onScrollAnimate from '@assets/js/scrollAnimate.js';
import { mapActions, mapGetters } from "vuex";
import {router} from "@src/routes";

export default {
    name: 'index',
    data() {
        return {
            template: '<main></main>',
            newReview: [],
            pagination: null,
            disableLoadMore: false,
        }
    },
    components: {
        'filter-container-cmp': filterContainer,
        'load-more-cmp': LoadMore,
        'form-reviews-cmp': formReviews,
        'reviews-item-cmp': reviewsItem,
    },
    computed: {
        ...mapGetters('lk', ['isAuth', 'linkAuth']),
    },
    methods: {
        ...mapActions('modal', ['modalType_reviewsOpen']),
        setPagination() {
            setTimeout(() => {
                this.pagination = this.$root.convertTwigToJs("pagination", ".js-pagination");
            }, 100)
        }
    },
    mounted() {
        this.setPagination();

        // если перешли со страницы о нас (слайдер с отзывами)
        let query = this.$route.query;
        setTimeout(() => {
            if (query.form) {
                this.$root.scrollToBlock('.js-reg-form');
            } else if (query.idReview) {
                document.querySelector('.js-' + query.idReview).click();
            }
        }, 1500);
    },
    beforeRouteUpdate(to, from, next) {
        // если не loadMore
        if (!to.query.loadMore) {
            const path = to.path.replace(router.history.base, '');
            this.$root.setDataAnimateFalse();

            Vue.http.get(`templates${path}`, { params: to.query }).then(
                (data) => {
                    next();
                    // this.$root.setDataAnimateTrue();
                    setTimeout(() => {
                        this.template = data.data;
                        this.setPagination();
                        // this.newReview = [];
                    }, 500);
                },
                () => {
                    next('/404');
                }
            );
        } else {
            this.disableLoadMore = true;
            let url = (process.env.NODE_ENV !== 'production') ?
                'reviews/index.json' :
                to.path.substring(1).replace(router.history.base, '');

            Vue.http.get(url, { params: to.query }).then(
                (data) => {
                    next();
                    this.newReview = this.newReview.concat(data.data.items);
                    this.pagination = data.data.pagination;
                    this.disableLoadMore = false;
                    setTimeout(() => {
                        onScrollAnimate();
                    }, 10);
                },
                () => {
                    this.disableLoadMore = false;
                    next('/404');
                }
            );
        }
    },
    beforeRouteEnter,
    render(createElement) {
        return Vue.compile(this.template).render.call(this, createElement);
    },
};


// WEBPACK FOOTER //
// ./src/templates/pages/reviews/index.js